import axios from '@dap/shared-utils/http.js';

export default {
    getASAAudienceDict () {
        return axios.get('/dapper/api/aud/asa/dict');
    },
    updateASAAudience (params) {
        return axios.post('/dapper/api/aud/asa/audience', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },
    getASAAudienceDetail (params) {
        return axios.get('/dapper/api/aud/asa/audience', { params });
    },
    getASAAudienceList (params) {
        return axios.get('/dapper/api/aud/asa/audiences', { params });
    },
    updateASAStatus (params) {
        return axios.put('/dapper/api/aud/asa/audience/status', params);
    },
    getASALocationList (params) {
        return axios.get('/dapper/api/aud/asa/audience/geo', { params });
    },
    getASAAudienceLog (params) {
        return axios.get('/dapper/api/aud/asa/audience/log', { params });
    },
    deleteASAAudience (params) {
        return axios.delete('/dapper/api/aud/asa/audience', { params });
    },
};
